var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterweavingCanvas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1D1D1B;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#EA0029;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8,8) scale(0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,6v68c0,1.1,0.4,2.2,1.2,3s1.9,1.2,3,1.2h42.5c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V6 c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2H18.7c-1.1,0-2.2,0.4-3,1.2S14.5,4.9,14.5,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.6,6v68c0,1.2,1,2.1,2.1,2.1h42.5c1.2,0,2.1-1,2.1-2.1V6c0-1.2-1-2.1-2.1-2.1H18.7c-0.6,0-1.1,0.2-1.5,0.6 C16.8,4.9,16.6,5.4,16.6,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.4,68.5L20,62.2c10.1-7,16.2-18.5,16.2-30.8v-4.6h-7.7L40,11.5l11.5,15.3h-7.7v4.6c0,12.3,6,23.8,16.2,30.8 l-4.3,6.3C48.8,63.8,43.4,57.2,40,49.6C36.6,57.2,31.2,63.8,24.4,68.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterweavingCanvas);
export default __webpack_public_path__ + "static/media/interweaving-canvas.b3565f8b0ff37d895ad8f47d8ea46266.svg";
export { ForwardRef as ReactComponent };